/**
 * Varibales de cortes para productos
 */
export const MARIPOSA = { code: 'mariposa', label: 'Mariposa' }
export const MOLIDA = { code: 'molida', label: 'Molida' }
export const TAJADA = { code: 'tajada', label: 'Tajada' }
export const ENTERO = { code: 'entero', label: 'Entero' }
